// extracted by mini-css-extract-plugin
export default {"heading":"ReturnsAndRefundsPage_heading__46tf4","content":"ReturnsAndRefundsPage_content__A9Ki6"};